import { Control } from 'react-hook-form'
import { Flex } from 'antd'

import { DateInputField } from 'ui/forms/fields/DateInputField'
import { InvoiceFormValues } from './schema'

interface InvoiceDateFieldsProps {
  control: Control<InvoiceFormValues>
}

const InvoiceDateFields = ({ control }: InvoiceDateFieldsProps) => {
  return (
    <Flex gap="1rem" wrap="wrap">
      <Flex flex="auto">
        <div className="full-width">
          <DateInputField
            control={control}
            name={'issueDate'}
            label={'Issue date'}
            placeholder={'Select an issue date'}
          />
        </div>
      </Flex>
      <Flex flex="auto">
        <div className="full-width">
          <DateInputField
            control={control}
            name={'deadline'}
            label={'Deadline'}
            placeholder={'Select a deadline'}
          />
        </div>
      </Flex>
    </Flex>
  )
}

export default InvoiceDateFields
